import React from 'react';
import Icon from '../icon';
import NodeDropdown from './NodeDropdown';
import {useData} from '../../../../context/ConfigDataContext';
import '../../../../styles/treeview.css';

const Circuit = ({nodeDatum}) => {
  const [isHidden, setIsHidden] = React.useState(true);
  const {deleteNode} = useData();

  const handleIconClick = () => setIsHidden(!isHidden);

  return (
    <>
      <div className="tree-node" style={{textAlign: 'left', overflow: 'visible'}}>
        <div onChange={handleIconClick}>
          <div className="mb-0 d-flex justify-content-between align-items-start">
            <div>
              <small style={{fontSize: 10}}>ID: {nodeDatum.name}</small>
              <h4>Circuit{nodeDatum.attributes?.circuitName && ' - ' + nodeDatum.attributes?.circuitName}</h4>
            </div>
            <div style={{position: 'relative'}} onClick={handleIconClick}>
              <div>
                <NodeDropdown isHidden={isHidden} nodeData={nodeDatum}/>
              </div>
              <div className="icon-hover">
                <Icon name="cable" color={'var(--blue)'} size={30}/>
              </div>
            </div>
          </div>
        </div>
        <br/>
        <div>
          <div>
            <h5>Measurement:</h5>
            <p className="mb-0">Type: {nodeDatum.attributes?.measurement?.type}</p>
            <p className="mb-0">Device: {nodeDatum.attributes?.measurement?.deviceName}</p>
          </div>
          <div>
            <b>Rules</b>
            <p className="mb-0">Decision interval: {nodeDatum.attributes?.controlSettings?.decissionInterval}s</p>
            <p className="mb-0">Safeguard: {nodeDatum.attributes?.controlSettings?.upperLimit}A</p>
          </div>
          <div>
            <b>Load Reset:</b>
            {nodeDatum.attributes?.actions && nodeDatum.attributes?.actions.length > 0 ? (
              <>
                <p className="mb-0">
                  Modus:
                  {nodeDatum.attributes?.actions[0]?.value === 1 && ' NC (Opener)'}
                  {nodeDatum.attributes?.actions[0]?.value === 0 && ' NO (Closer)'}
                  {nodeDatum.attributes?.actions[0]?.value === undefined && ' Nicht konfiguriert'}
                </p>
                {nodeDatum.attributes?.actions[0]?.deviceName && (
                  <p className="mb-0">Device: {nodeDatum.attributes?.actions[0]?.deviceName}</p>
                )}
              </>
            ) : (
              <p className="mb-0">Not configured</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Circuit;

